module.exports = __webpack_public_path__ + "static/media/react.a7bfa93b.png";